import { useState } from "react";

export default function TableAdmin({
  columns = [], // [{ key: "name", label: "نام" }]
  data = [], // [{ name: "علی", age: 21 }]
  isLTR = "",
  isEnglish = [],
  multipleSelect = false,
  onTableScroll,
  bottomContent = null,
  // optional: if parent wants to control selection
  selectedIndex: controlledSelectedIndex,
  onSelectedIndexChange,
  onRowClick,
}) {
  const [uncontrolledSelectedIndex, setUncontrolledSelectedIndex] = useState(
    multipleSelect ? [] : null
  );

  const selectedIndex =
    controlledSelectedIndex !== undefined
      ? controlledSelectedIndex
      : uncontrolledSelectedIndex;

  const setSelectedIndex = (next) => {
    if (typeof onSelectedIndexChange === "function") {
      onSelectedIndexChange(next);
    } else {
      setUncontrolledSelectedIndex(next);
    }
  };

  const toggleRow = (rowIndex) => {
    if (multipleSelect) {
      const current = Array.isArray(selectedIndex) ? selectedIndex : [];
      const exists = current.includes(rowIndex);

      const next = exists
        ? current.filter((i) => i !== rowIndex)
        : [...current, rowIndex];

      setSelectedIndex(next);

      // 🔥 notify parent
      if (onRowClick) {
        if (next.length === 0) {
          onRowClick(null);
        } else {
          onRowClick(next.map((i) => data[i]?.id));
        }
      }
    } else {
      const next = selectedIndex === rowIndex ? null : rowIndex;
      setSelectedIndex(next);

      // 🔥 notify parent
      if (onRowClick) {
        if (next === null) {
          onRowClick(null);
        } else {
          onRowClick(data[rowIndex]?.id);
        }
      }
    }
  };

  return (
    <div className="rounded-lg border border-zi-border-light dark:border-zi-border-dark overflow-hidden">
      <div
        className="overflow-auto w-full max-h-[275px]"
        onScroll={onTableScroll}
      >
        <table className="w-full min-h-0 flex-1 text-sm text-zi-text-light text-nowrap dark:text-zi-text-dark border-separate border-spacing-0">
          <thead className="sticky top-0 z-20 bg-zi-bg1-light dark:bg-zi-bg1-dark shadow-[inset_0_-1px_0_0_rgba(40,120,163,0.5)]">
            <tr>
              {/* Select column MUST be first so in RTL layouts it stays on the RIGHT */}
              <th className="px-3 py-3 text-center font-normal">انتخاب</th>
              {columns.map((col, i) => (
                <th key={i} className="px-3 py-3 text-center font-normal">
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y divide-zi-border-light dark:divide-zi-border-dark/50">
            {data.map((row, rowIndex) => {
              const isSelected = multipleSelect
                ? Array.isArray(selectedIndex) &&
                  selectedIndex.includes(rowIndex)
                : selectedIndex === rowIndex;

              return (
                <tr
                  key={rowIndex}
                  onClick={() => {
                    toggleRow(rowIndex);
                  }}
                  className={
                    `${
                      isSelected
                        ? "bg-zi-blue-light/10"
                        : "hocus:bg-zi-bg1-light/50 dark:hocus:bg-zi-bg1-dark/50"
                    } ` + " cursor-pointer "
                  }
                >
                  {/* Select cell */}
                  <td className="text-center px-3 py-3">
                    <button
                      type="button"
                      aria-label={isSelected ? "انتخاب شده" : "انتخاب"}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleRow(rowIndex);
                      }}
                      className={
                        "inline-flex size-5 items-center justify-center rounded-md transition-all " +
                        (isSelected
                          ? "bg-zi-blue-light"
                          : "bg-transparent ring-1 ring-inset ring-zi-blue-light/50")
                      }
                    >
                      <span
                        className={`text-xs ${
                          isSelected === true
                            ? "text-zi-text-dark"
                            : "text-transparent"
                        }`}
                      >
                        ✓
                      </span>
                      {/* {isSelected && <span className="text-white text-xs">✓</span>} */}
                    </button>
                  </td>

                  {/* Custom columns */}
                  {columns.map((col, colIndex) => (
                    <td
                      key={colIndex}
                      className={`text-center px-3 py-3 ${
                        isLTR ||
                        (Array.isArray(isEnglish) &&
                          isEnglish.includes(colIndex))
                          ? "[direction:ltr]"
                          : ""
                      }`}
                    >
                      {col.render
                        ? col.render(row[col.key], row)
                        : row[col.key]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
        {bottomContent}
      </div>
    </div>
  );
}
